export enum InfoCardType {
  CardSmallPlain = 'card-small-plain',
  CardWidePlain = 'card-wide-plain',
  CardSmallVisual = 'card-small-visual',
  CardWideVisual = 'card-wide-visual',
  CardWidePlainTeal = 'card-wide-plain-teal',
}
